import { render } from "./FooterTienda.vue?vue&type=template&id=21d9258a&scoped=true"
import script from "./FooterTienda.vue?vue&type=script&lang=js"
export * from "./FooterTienda.vue?vue&type=script&lang=js"

import "./FooterTienda.vue?vue&type=style&index=0&id=21d9258a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d9258a"]])

export default __exports__